import {
  Card,
  Container,
  Stack,
  Typography,
  Button,
  Backdrop,
  CircularProgress
} from '@mui/material';
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { leaguesSelector, allLeagues, updateLeague } from '../slices/leaguesSlices';
import Page from '../components/Page';
import { ApiStatus } from '../utils/constants';

function Leagues() {
  const { leagues, status } = useSelector(leaguesSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (leagues.length <= 0) {
      dispatch(allLeagues());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leagues]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'icon',
      headerName: '',
      width: 40,
      sortable: false,
      renderCell: (params) => (
        <img alt="" src={process.env.REACT_APP_IMAGE_URL + params.row.image} />
      )
    },
    {
      field: 'title',
      headerName: 'Title',
      width: 150
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Button variant="contained" component="label">
            Icon
            <input
              type="file"
              name="image"
              hidden
              onChange={(event) => {
                event.stopPropagation();
                if (event.target.files) {
                  const file = event.target.files[0];
                  const formData = new FormData();
                  formData.append('key', params.row.key);
                  formData.append('image', file);
                  dispatch(updateLeague(formData));
                }
              }}
            />
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to={`/dashboard/teams/${params.row.id}`}
          >
            Teams
          </Button>
        </Stack>
      )
    }
  ];

  return (
    <Page title="Leagues">
      <Backdrop style={{ zIndex: 100, color: '#fff' }} open={status === ApiStatus.loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Leagues
          </Typography>
        </Stack>
        <Card sx={{ height: '400px' }}>
          <DataGrid
            rows={leagues}
            columns={columns}
            pageSize={6}
            rowsPerPageOptions={[6]}
            checkboxSelection
            disableSelectionOnClick
          />
        </Card>
      </Container>
    </Page>
  );
}

export default Leagues;
